import React, { useEffect, useState, useRef } from "react";
import Header from "../common/Header";
import { useParams } from "react-router-dom";
import apiCall from "../common/Utils/helper";
import SliderPopup from "./SliderPopup";

const GalleryEdit = () => {
  const [galleryData, setGalleryData] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showSlider, setShowSlider] = useState(false);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [allDataFetched, setAllDataFetched] = useState(false);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [folderName, setFolderName] = useState("second");
  const { folderId } = useParams();
  const galleryRef = useRef(null);
  const loadMoreButtonRef = useRef(null);

  const handleCancel = () => {
    setShowSlider(false);
  };

  const fetchData = async () => {
    if (loading || allDataFetched) return;
    setLoading(true);

    try {
      const result = await apiCall("post", "/getdatabyfolder", {
        folderId,
        offset,
      });
      if (result.resultFlag === 1) {
        // Set gallery data
        setGalleryData((prevData) => [...prevData, ...result.response.files]);

        const newFolderName =
          result.response.files.length > 0
            ? result.response.files[0].folder_name
            : galleryData.length > 0 && galleryData[0].folder_name;
        setFolderName(newFolderName);

        setOffset((prevOffset) => prevOffset + result.response.files.length);

        if (
          result.response.files.length === 0 ||
          result.response.files.length < 19
        ) {
          setAllDataFetched(true);
        }
      } else {
        console.error("Failed to retrieve data for folder:", result.message);
      }
    } catch (error) {
      console.error("Error fetching data for folder:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let selected = {};
    for (let i = 0; i < galleryData.length; i++) {
      let element = galleryData[i];
      if (element.at_home > 0) {
        selected[element.at_home] = i;
      }
    }
    let selectedAry = Object.values(selected);
    setSelectedImages(selectedAry);
  }, [galleryData]);

  useEffect(() => {
    // Intersection Observer for modern browsers
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading && !allDataFetched) {
          fetchData();
        }
      },
      { threshold: 1 }
    );

    if (galleryRef.current && !allDataFetched) {
      observer.observe(galleryRef.current);
    }

    // Scroll event listener fallback for older browsers
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100 &&
        !loading &&
        !allDataFetched
      ) {
        fetchData();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (galleryRef.current && !allDataFetched) {
        observer.unobserve(galleryRef.current);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [folderId, offset, loading, allDataFetched]);

  const handleLoadMore = () => {
    if (!loading && !allDataFetched) {
      setLoading(true);
      fetchData();
    }
  };

  const handleImageSelect = (index) => {
    if (selectedImages.length < 4) {
      setSelectedImages((prevSelected) => {
        if (!prevSelected.includes(index)) {
          return [...prevSelected, index];
        }
        return prevSelected;
      });
    }
  };

  const handleImageDeselect = (index) => {
    setSelectedImages((prevSelected) =>
      prevSelected.filter((item) => item !== index)
    );
  };

  const handleDone = async () => {
    if (selectedImages.length === 4) {
      const confirmation = window.confirm("Are you sure you want to proceed ?");
      if (confirmation) {
        try {
          // creating array of objects
          const selectedAssets = selectedImages.map((index, i) => ({
            asset_id: galleryData[index].asset_id,
            folder_id: folderId,
            sequence_no: i + 1,
          }));

          // API call
          const result = await apiCall(
            "post",
            "/updatesequencenumber",
            selectedAssets
          );

          if (result.resultFlag === 1) {
            alert("Edit completed successfully!");
          } else {
            console.error("API call failed:", result.message);
            alert("Failed to complete edit. Please try again later.");
          }
        } catch (error) {
          console.error("Error completing edit:", error);
          alert(
            "An error occurred while completing edit. Please try again later."
          );
        }
      }
    } else {
      alert("Please select images to complete the edit.");
    }
  };

  // console.log(selectedImages);

  return (
    <>
      <Header folderName={folderName} />
      {selectedImages.length < 5 &&
        selectedImages.length > 0 && ( //min 1 max 4 images
          <div style={{ textAlign: "center" }}>
            <button
              onClick={handleDone}
              style={{
                backgroundColor: "blue",
                color: "white",
                borderRadius: "5px",
                padding: "10px 20px",
                cursor: "pointer",
                border: "none",
                outline: "none",
                marginTop: "10px",
              }}
            >
              Done
            </button>
          </div>
        )}
      <div className="list_section" ref={galleryRef}>
        <div className="photonav_container">
          <ul className="photo_gallery_list">
            {galleryData.map((item, index) => (
              <li key={index}>
                <input
                  type="checkbox"
                  checked={selectedImages.includes(index)}
                  onChange={() => {
                    if (selectedImages.includes(index)) {
                      handleImageDeselect(index);
                    } else {
                      handleImageSelect(index);
                    }
                  }}
                  disabled={
                    selectedImages.length === 4 &&
                    !selectedImages.includes(index)
                  }
                />
                <span>
                  {selectedImages.indexOf(index) !== -1
                    ? selectedImages.indexOf(index) + 1
                    : null}
                </span>
                <img
                  src={`https://new-dam-java.b-cdn.net/${item.file_path}?width=300`}
                  alt={item.file_name}
                  className="gallery_image"
                  onClick={() => {
                    setSliderIndex(index);
                    setShowSlider(true);
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
        {!allDataFetched && (
          <button
            ref={loadMoreButtonRef}
            onClick={handleLoadMore}
            style={{
              backgroundColor: "blue",
              color: "white",
              borderRadius: "5px",
              padding: "10px 20px",
              margin: "auto",
              display: "block",
              marginTop: "20px",
              cursor: "pointer",
            }}
          >
            Load More
          </button>
        )}
      </div>
      {showSlider && (
        <SliderPopup
          galleryData={galleryData}
          initialIndex={sliderIndex}
          onCancel={handleCancel}
          folderName={folderName}
        />
      )}
      {/* {selectedImages.length === 4 && (
        <button onClick={handleDone}>Done</button>
      )} */}
    </>
  );
};

export default GalleryEdit;
